import { Injectable } from '@angular/core';
import { EToastPosition } from '../enumerables';
import { IMiningToast } from '../interfaces/mining-toast';
import { IMiningToastConfig } from '../interfaces/mining-toast-config';
import { MiningToastManagerService } from './mining-toast-manager.service';

@Injectable({
  providedIn: 'root',
})
export class MiningToastService {
  private defaultConfig: IMiningToastConfig;

  constructor(private miningToastManagerService: MiningToastManagerService) {}

  /**
   * Function that generates a success toast
   *
   * @param title: Toast title
   * @param message: Toast message
   */
  public success(title: string, message: string, config?: IMiningToastConfig): void {
    this.setDefaultConfig();
    this.defaultConfig.class = `toast-success ${config.position}`;
    const toast: IMiningToast = {
      title,
      message,
      config: config ? this.compareConfig(config) : this.defaultConfig,
    };

    this.miningToastManagerService.createToast(toast);
  }

  /**
   * Function that generates a warning toast
   *
   * @param title: Toast title
   * @param message: Toast message
   */
  public warning(title: string, message: string, config?: IMiningToastConfig): void {
    this.setDefaultConfig();
    this.defaultConfig.class = `toast-warning ${config.position}`;
    const toast: IMiningToast = {
      title,
      message,
      config: config ? this.compareConfig(config) : this.defaultConfig,
    };

    this.miningToastManagerService.createToast(toast);
  }

  /**
   * Function that generates an error toast
   *
   * @param title: Toast title
   * @param message: Toast message
   */
  public error(title: string, message: string, config?: IMiningToastConfig): void {
    this.setDefaultConfig();
    this.defaultConfig.class = `toast-error ${config.position}`;
    const toast: IMiningToast = {
      title,
      message,
      config: config ? this.compareConfig(config) : this.defaultConfig,
    };

    this.miningToastManagerService.createToast(toast);
  }

  /**
   * Function that set default config
   */
  private setDefaultConfig(): void {
    this.defaultConfig = {
      class: '',
      closeOnClick: true,
      onClose: () => {},
      position: EToastPosition.bottomRight,
      delay: 10000,
    };
  }

  /**
   * Function that compares and complete the user configuration
   *
   * @param config: User config (if the user send)
   */
  private compareConfig(config: IMiningToastConfig): IMiningToastConfig {
    const newConfig: IMiningToastConfig = {
      class: config.class ? config.class : this.defaultConfig.class,
      closeOnClick:
        Boolean(config.closeOnClick) === true || Boolean(config.closeOnClick) === false
          ? Boolean(config.closeOnClick)
          : this.defaultConfig.closeOnClick,
      onClose: config.onClose ? config.onClose : this.defaultConfig.onClose,
      position: config.position ? config.position : this.defaultConfig.position,
      delay: config.delay ? config.delay : this.defaultConfig.delay,
    };
    return newConfig;
  }
}
